import React from 'react';
import HeroBanner from '../components/HeroBanner';
import PrincipalMessage from '../components/PrincipalMessage';
import AboutSection from '../components/AboutSection';
import EventsSection from '../components/EventsSection';
import GallerySection from '../components/GallerySection';
import AlumniSection from '../components/AlumniSection';
import PartnersSlider from '../components/PartnersSlider';
import Footer from '../components/Footer';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <HeroBanner />
      <AboutSection />
      <PrincipalMessage />
      <EventsSection />
      <GallerySection />
      <AlumniSection />
      <PartnersSlider />
      <Footer />
    </div>
  );
};

export default Home;
